module.exports = __webpack_public_path__ + "static/media/Back-Of-Head v2.52747333.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Back-Of-Head v2.png
// module id = 1175
// module chunks = 0